import React, { ReactElement } from "react"

import { Autocomplete, AutocompleteProps, AutocompleteRenderInputParams } from "@mui/material"

import { TextField } from "../../atoms"
import { useStyles } from "./styles"
import { renderTags } from "./helper"

type OriginalProps = AutocompleteProps<any, any, any, any> 

type Props = Omit<OriginalProps, "renderInput"> & {
  height?: number | string,
  InputProps?: Object,
  label?: string,
  startAdornment?: ReactElement,
  triggerLength?: number,
  width?: number | string,
  inputRef?: React.Ref<any>
  renderTag?: (value: any) => string
  renderInput?: OriginalProps["renderInput"]
}

export const Combobox = ({
                           height,
                           label,
                           inputRef,
                           width = 300,
                           InputProps,
                           triggerLength,
                           startAdornment,
                           renderTag = (option) => option.title || option,
                           ...props
                         }: Props) => {
  const classes = useStyles({ height })

  return <Autocomplete
    autoComplete={true}
    blurOnSelect={true}
    classes={classes}
    clearOnBlur={false}
    disableCloseOnSelect={false}
    freeSolo={false}
    forcePopupIcon={false}
    limitTags={1}
    openOnFocus={true}
    renderTags={(value, getTagProps) => renderTags(value, getTagProps, renderTag)}
    value={props.value}

    renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField
          {...params}
          label={label}
          placeholder={label || props.placeholder}
          width={width}
          InputProps={{
            ...params.InputProps,
            ...InputProps,
            ...(startAdornment && { startAdornment:  (
              <>
                {params.InputProps.startAdornment}
                {startAdornment}
              </>
            )}),
          }}
          sx={{ height }}
          inputRef={params.InputProps.ref}
        />
      )
    }
    {...props}
  />
}
